export default __webpack_public_path__ + "static/media/47k.60973658.md";